import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type BookLibraryCollectionService from 'teacher-ui-client/services/book-library/collection'

export default class BookLibraryRoute extends Route {
  @service('book-library/collection') collectionService!: BookLibraryCollectionService

  queryParams = {
    bookId: {
      refreshModel: false,
      replace: true,
    },
    bookTab: {
      refreshModel: false,
      replace: true,
    },
  }

  setupController(...args: Parameters<Route['setupController']>) {
    super.setupController(...args)
    void this.collectionService.loadAllMyCollections.perform()
  }
}
